import { UrlActionButtons } from '@shared/components/UrlActionButtons';
import { View } from '@shared/components/View';
import { Link } from '@shared/components/link';
import { TruncateLink } from '@shared/components/truncate';
import { UrlField } from '@shared/data/entity/fields/UrlField';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: UrlField;
}

export function UrlCollectionViewField({ field }: Props) {
  if (field.isEmpty) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer fieldType={field.fieldType}>
      <View row centerVertically>
        {/* On the View because Link doesn't pass extra props to its anchor. */}
        <View centerVertically style={{ flexShrink: 1 }} tooltip={field.url}>
          <Link href={field.url}>
            <TruncateLink href={field.url} />
          </Link>
        </View>
        <View paddingLeft={1}>
          <UrlActionButtons url={field.url} showOpen={false} />
        </View>
      </View>
    </CardCollectionViewFieldContainer>
  );
}
